import { render } from "./CookiesDomPrint.vue?vue&type=template&id=2f69fd3c&scoped=true&ts=true"
import script from "./CookiesDomPrint.vue?vue&type=script&lang=ts"
export * from "./CookiesDomPrint.vue?vue&type=script&lang=ts"

import "./CookiesDomPrint.vue?vue&type=style&index=0&id=2f69fd3c&lang=css"
import "./CookiesDomPrint.vue?vue&type=style&index=1&id=2f69fd3c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f69fd3c"]])

export default __exports__